import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
  Button,
  Switch,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/apartment/x-circle.svg";
import {
  InputControl,
  SelectControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useCategories } from "../../../categorys/apartments/detail";
import { formatPriceUS } from "../../../utils/utils";
import { projectCall } from "../../../api/project";
import { useSelector } from "react-redux";
import { employeeCall } from "../../../api/employee";

const REACT_APP_ROUTE_RATE =
  process.env.REACT_APP_ROUTE_RATE ||
  "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT";

const schema = Yup.object().shape({
  code: Yup.string().required("Mã căn hộ là bắt buộc"),
  name: Yup.string(),
  // .required("Tên căn hộ là bắt buộc")
  apartmentTypeId: Yup.string(),
  // .required("Loại hình là bắt buộc")
  directionId: Yup.string(),
  // .required("Hướng là bắt buộc"),
  propertyId: Yup.string(),
  // .required("Tính chất là bắt buộc"),
  projectId: Yup.string().required("Dự án là bắt buộc"),
  divisionId: Yup.string(),
  // .required("Phân khu là bắt buộc"),
  area: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // .required("Diện tích đất là bắt buộc"),
  builtUpArea: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // .required("Diện tích xây dựng là bắt buộc"),
  length: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // .required("Chiều dài là bắt buộc"),
  width: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // .required("Chiều rộng là bắt buộc"),
  numberOfBedrooms: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // .required("Phòng ngủ là bắt buộc"),
  numberOfToilets: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // .required("Phòng vệ sinh là bắt buộc"),
  totalValue: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .moreThan(0, "Giá bán niêm yết phải lớn hơn 0")
    .required("Giá bán niêm yết là bắt buộc"),
  priceForCommission: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  areaOfWater: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  // kRate: Yup.number()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string") {
  //       return originalValue.trim() === "" ? null : Number(originalValue);
  //     }
  //     return originalValue === null ? null : Number(originalValue);
  //   })
  //   .nullable()
  //   .moreThan(-1, "Hệ số K phải lớn hơn 0")
  //   .max(100, "Hệ số K nhỏ hơn hoặc bằng 100"),

  hotBonusPercent: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .nullable()
    .moreThan(-1, "Phần trăm thưởng nóng phải lớn hơn 0")
    .max(100, "Phần trăm thưởng tối đa là 100"),

  priceTNSan: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
  transactionRate: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .nullable()
    .moreThan(-1, "Tỉ lệ nhân về phải lớn hơn 0")
    .max(100, "Tỉ lệ nhân về tối đa là 100"),
  rateTNSan: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .nullable()
    .moreThan(-1, "Tỉ lệ thưởng nóng sàn phải lớn hơn 0")
    .max(100, "Tỉ lệ thưởng nóng tối đa là 100"),
});

const FormNew = ({ isOpen, onClose, isEdit, onSubmit, defaultValues }) => {
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {},
  });

  const user = useSelector((state) => state.auth.login?.currentUser);

  const [focusStates, setFocusStates] = useState({});
  const [shouldFetch, setShouldFetch] = useState(false);
  const [displayValuePriceForCommission, setDisplayValuePriceForCommission] =
    useState(0);
  const [displayValueTotalValue, setDisplayValueTotalValue] = useState(0);
  const [displayEstimatedServiceFeePrice, setDisplayEstimatedServiceFeePrice] =
    useState(0);
  const [displayPriceTNSan, setDisplayPriceTNSan] = useState(0);
  const [getRoleUser, setGetRoleUser] = useState(false);

  const onChangePriceForCommission = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayValuePriceForCommission(formatPriceUS(numericValue));
      setValue("priceForCommission", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );
  const onChangeValueTotalValue = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayValueTotalValue(formatPriceUS(numericValue));
      setValue("totalValue", Number(numericValue), { shouldValidate: true });
    },
    [setValue, watch, formatPriceUS],
  );
  const onChangePriceAfterDiscount = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayEstimatedServiceFeePrice(formatPriceUS(numericValue));
      setValue("estimatedServiceFeePrice", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );
  const onChangePriceTNSan = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayPriceTNSan(formatPriceUS(numericValue));
      setValue("priceTNSan", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS],
  );

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      if (defaultValues?.id) {
        reset(defaultValues);
        setDisplayValuePriceForCommission(
          formatPriceUS(defaultValues?.priceForCommission || 0),
        );
        setDisplayValueTotalValue(
          formatPriceUS(defaultValues?.totalValue || 0),
        );
        setDisplayEstimatedServiceFeePrice(
          formatPriceUS(defaultValues?.estimatedServiceFeePrice || 0),
        );
        setDisplayPriceTNSan(formatPriceUS(defaultValues?.priceTNSan || 0));
      } else {
        reset({
          priceForCommission: 0,
          totalValue: 0,
          estimatedServiceFeePrice: 0,
        });

        setDisplayValuePriceForCommission(
          formatPriceUS(defaultValues?.priceForCommission || 0),
        );
        setDisplayValueTotalValue(
          formatPriceUS(defaultValues?.totalValue || 0),
        );
        setDisplayEstimatedServiceFeePrice(
          formatPriceUS(defaultValues?.estimatedServiceFeePrice || 0),
        );
        setDisplayPriceTNSan(formatPriceUS(defaultValues?.priceTNSan || 0));
      }
    }
  }, [isOpen, defaultValues, reset]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  const { constantData } = useCategories(
    null,
    watch("projectId"),
    null,
    shouldFetch,
  );
  // console.log(constantData);
  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));

  const directions = useMemo(
    () => formatEntries(constantData?.direction),
    [constantData?.direction],
  );
  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project],
  );
  const apartmentTypes = useMemo(
    () => formatEntries(constantData?.apartmentType),
    [constantData?.apartmentType],
  );
  const divisions = useMemo(
    () => formatEntries(constantData?.division),
    [constantData?.division],
  );
  const propertys = useMemo(
    () => formatEntries(constantData?.property),
    [constantData?.property],
  );
  const saleOpeningEvents = useMemo(
    () => formatEntries(constantData?.saleOpeningEvent),
    [constantData?.saleOpeningEvent],
  );

  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const onchangeApartmentType = (option) => {
    setValue("apartmentTypeId", option);
  };
  const onchangeDirection = (option) => {
    setValue("directionId", option);
  };
  const onchangeProperty = (option) => {
    setValue("propertyId", option);
  };
  const onchangeSaleOpeningEvent = (option) => {
    setValue("saleOpeningEventId", option);
  };

  const onchangeProject = (option) => {
    clearErrors("divisionId");
    setValue("projectId", option);
    setValue("saleOpeningEventId", "");

    if (watch("projectId")) {
      const fetchData = async () => {
        try {
          // const project = await projectCall.getById(watch("projectId"));
          // if (project?.commissionFromInvestor) {
          //   setValue(
          //     "commissionFromInvestor",
          //     Number(project?.commissionFromInvestor)
          //   );
          // }
          // if (project?.commissionFromPartner) {
          //   setValue(
          //     "commissionFromPartner",
          //     Number(project?.commissionFromPartner)
          //   );
          // }
          // if (project?.commissionToSales) {
          //   setValue("commissionToSales", Number(project?.commissionToSales));
          // }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  };
  const onchangeDivision = (option) => {
    if (!watch("projectId")) {
      setError("divisionId", {
        type: "manual",
        message: "Bạn phải chọn dự án trước khi chọn phân khu",
      });
      return;
    }
    setValue("divisionId", option);
  };

  const submitHandler = (data) => {
    // console.log(data);
    onSubmit(data);
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        paddingBottom={"25px"}
        h={"86.5vh"}
        w={"100%"}
        maxW={"625px"}
        overflowY={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
          "&::-moz-scrollbar": {
            width: "4px",
          },
          "&::-moz-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
        }}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Flex minH={"800px"} flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                {isEdit ? "Sửa căn hộ" : "Tạo căn hộ mới"}
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIconBlack} />
              </Box>
            </Flex>
            <Box flex={1} w={"545px"} m={"24px auto"}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Mã căn hộ"
                  placeholder="Nhập mã căn hộ"
                  errors={errors.code}
                  register={register("code")}
                  onFocus={() => handleFocus("code")}
                  onBlur={() => handleBlur("code")}
                  state={focusStates["code"]}
                  isRequired={true}
                />
                <InputControl
                  label="Tên căn hộ"
                  placeholder="Nhập tên căn hộ"
                  // errors={errors.name}
                  register={register("name")}
                  onFocus={() => handleFocus("name")}
                  onBlur={() => handleBlur("name")}
                  state={focusStates["name"]}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label="Loại hình"
                  dataOption={apartmentTypes}
                  placeholder="Chọn loại hình căn hộ"
                  selectedMain={watch("apartmentTypeId")}
                  onChange={onchangeApartmentType}
                  onFocus={() => handleFocus("apartmentTypeId")}
                  onBlur={() => handleBlur("apartmentTypeId")}
                  state={focusStates["apartmentTypeId"]}
                  registerProps={register("apartmentTypeId")}
                  // errorMessage={errors.apartmentTypeId}
                  isSearchable={true}
                  mwidth="100%"
                  // isRequired={true}
                />
                <SelectControl
                  label="Hướng"
                  dataOption={directions}
                  placeholder="Chọn hướng căn hộ"
                  selectedMain={watch("directionId")}
                  onChange={onchangeDirection}
                  onFocus={() => handleFocus("directionId")}
                  onBlur={() => handleBlur("directionId")}
                  state={focusStates["directionId"]}
                  registerProps={register("directionId")}
                  // errorMessage={errors.directionId}
                  mwidth="100%"
                  // isRequired={true}
                  isSearchable={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label="Tính chất"
                  dataOption={propertys}
                  placeholder="Chọn tính chất căn hộ"
                  selectedMain={watch("propertyId")}
                  onChange={onchangeProperty}
                  onFocus={() => handleFocus("propertyId")}
                  onBlur={() => handleBlur("propertyId")}
                  state={focusStates["propertyId"]}
                  registerProps={register("propertyId")}
                  // errorMessage={errors.propertyId}
                  mwidth="259px"
                  // isRequired={true}
                  isSearchable={true}
                />
                <SelectControl
                  label="Phân khu"
                  dataOption={divisions}
                  placeholder="Chọn phân khu"
                  selectedMain={watch("divisionId")}
                  onChange={onchangeDivision}
                  onFocus={() => handleFocus("divisionId")}
                  onBlur={() => handleBlur("divisionId")}
                  state={focusStates["divisionId"]}
                  registerProps={register("divisionId")}
                  // errorMessage={errors.divisionId}
                  // isRequired={true}
                  isSearchable={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label="Dự án"
                  dataOption={projects}
                  placeholder="Chọn dự án"
                  selectedMain={watch("projectId")}
                  onChange={onchangeProject}
                  onFocus={() => handleFocus("projectId")}
                  onBlur={() => handleBlur("projectId")}
                  state={focusStates["projectId"]}
                  registerProps={register("projectId")}
                  errorMessage={errors.projectId}
                  isSearchable={true}
                  mwidth="259px"
                  isRequired={true}
                />
                <SelectControl
                  label="Đợt mở bán"
                  dataOption={saleOpeningEvents}
                  placeholder="Chọn đợt mở bán"
                  selectedMain={watch("saleOpeningEventId")}
                  onChange={onchangeSaleOpeningEvent}
                  onFocus={() => handleFocus("saleOpeningEventId")}
                  onBlur={() => handleBlur("saleOpeningEventId")}
                  state={focusStates["saleOpeningEventId"]}
                  registerProps={register("saleOpeningEventId")}
                  isSearchable={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type="number"
                  label="DT đất (m2)"
                  placeholder="ví dụ:120"
                  onFocus={() => handleFocus("area")}
                  onBlur={() => handleBlur("area")}
                  state={focusStates["area"]}
                  // errors={errors.area}
                  register={register("area")}
                  // isRequired={true}
                  onlyPositiveNumbers={true}
                />
                <InputControl
                  type="number"
                  label="DT xây dựng (m2)"
                  placeholder="ví dụ:12"
                  onFocus={() => handleFocus("builtUpArea")}
                  onBlur={() => handleBlur("builtUpArea")}
                  state={focusStates["builtUpArea"]}
                  // errors={errors.builtUpArea}
                  register={register("builtUpArea")}
                  // isRequired={true}
                  onlyPositiveNumbers={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <Flex
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  gap={"17px"}
                >
                  <InputControl
                    type="number"
                    label="Chiều dài (m)"
                    placeholder="ví dụ:10"
                    onFocus={() => handleFocus("length")}
                    onBlur={() => handleBlur("length")}
                    state={focusStates["length"]}
                    // errors={errors.length}
                    register={register("length")}
                    // isRequired={true}
                    onlyPositiveNumbers={true}
                  />
                  <InputControl
                    type="number"
                    label="Chiều rộng (m)"
                    placeholder="ví dụ:15"
                    onFocus={() => handleFocus("width")}
                    onBlur={() => handleBlur("width")}
                    state={focusStates["width"]}
                    // errors={errors.width}
                    register={register("width")}
                    // isRequired={true}
                    onlyPositiveNumbers={true}
                  />
                </Flex>
                <Flex
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  gap={"17px"}
                  maxW={"259px"}
                >
                  <InputControl
                    type="number"
                    label="Phòng ngủ"
                    placeholder="Số phòng ngủ"
                    onFocus={() => handleFocus("numberOfBedrooms")}
                    onBlur={() => handleBlur("numberOfBedrooms")}
                    state={focusStates["numberOfBedrooms"]}
                    // errors={errors.numberOfBedrooms}
                    register={register("numberOfBedrooms")}
                    // isRequired={true}
                    onlyPositiveNumbers={true}
                  />
                  <InputControl
                    type="number"
                    label="Phòng VS"
                    placeholder="Số phòng VS"
                    onFocus={() => handleFocus("numberOfToilets")}
                    onBlur={() => handleBlur("numberOfToilets")}
                    state={focusStates["numberOfToilets"]}
                    // errors={errors.numberOfToilets}
                    register={register("numberOfToilets")}
                    // isRequired={true}
                    onlyPositiveNumbers={true}
                  />
                </Flex>
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  // type="number"
                  label="Giá bán niêm yết"
                  placeholder="Ví dụ: 1000000000 "
                  onFocus={() => handleFocus("totalValue")}
                  onBlur={() => handleBlur("totalValue")}
                  state={focusStates["totalValue"]}
                  onChange={onChangeValueTotalValue}
                  value={displayValueTotalValue}
                  errors={errors.totalValue}
                  register={register("totalValue")}
                  isRequired={true}
                />
                <InputControl
                  // type="number"
                  label="Giá tính phí dịch vụ"
                  onChange={onChangePriceForCommission}
                  value={displayValuePriceForCommission}
                  placeholder="Ví dụ: 15000000000 "
                  onFocus={() => handleFocus("priceForCommission")}
                  onBlur={() => handleBlur("priceForCommission")}
                  state={focusStates["priceForCommission"]}
                  // errors={errors.priceForCommission}
                  register={register("priceForCommission")}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type="number"
                  label="Diện tích thông thủy"
                  placeholder="Nhập diện tích thông thủy"
                  onFocus={() => handleFocus("areaOfWater")}
                  onBlur={() => handleBlur("areaOfWater")}
                  state={focusStates["areaOfWater"]}
                  register={register("areaOfWater")}
                  onlyPositiveNumbers={true}
                />
                <InputControl
                  // type="number"
                  label="Giá tính phí dịch vụ ước tính"
                  onChange={onChangePriceAfterDiscount}
                  value={displayEstimatedServiceFeePrice}
                  placeholder="Ví dụ: 15000000000 "
                  onFocus={() => handleFocus("estimatedServiceFeePrice")}
                  onBlur={() => handleBlur("estimatedServiceFeePrice")}
                  state={focusStates["estimatedServiceFeePrice"]}
                  // errors={errors.estimatedServiceFeePrice}
                  register={register("estimatedServiceFeePrice")}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type="number"
                  label="Diện tích tim tường (m2)"
                  placeholder="ví dụ:120"
                  onFocus={() => handleFocus("grossFloorArea")}
                  onBlur={() => handleBlur("grossFloorArea")}
                  state={focusStates["grossFloorArea"]}
                  // errors={errors.grossFloorArea}
                  register={register("grossFloorArea")}
                  // isRequired={true}
                  onlyPositiveNumbers={true}
                />

                <InputControl
                  type="number"
                  // step="any"
                  label="Phần trăm thưởng nóng"
                  placeholder="Nhập phần trăm thưởng nóng"
                  errors={errors.hotBonusPercent}
                  register={register("hotBonusPercent")}
                  onFocus={() => handleFocus("hotBonusPercent")}
                  onBlur={() => handleBlur("hotBonusPercent")}
                  state={focusStates["hotBonusPercent"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  // isRate={true}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type="number"
                  // step="any"
                  label="Tỉ lệ nhân về"
                  placeholder="Nhập tỉ lệ nhân về"
                  errors={errors.transactionRate}
                  register={register("transactionRate")}
                  onFocus={() => handleFocus("transactionRate")}
                  onBlur={() => handleBlur("transactionRate")}
                  state={focusStates["transactionRate"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  isRate={true}
                />

                <InputControl
                  type="number"
                  // step="any"
                  label="Tỉ lệ thưởng nóng sàn"
                  placeholder="Nhập tỉ lệ thưởng nóng sàn"
                  errors={errors.rateTNSan}
                  register={register("rateTNSan")}
                  onFocus={() => handleFocus("rateTNSan")}
                  onBlur={() => handleBlur("rateTNSan")}
                  state={focusStates["rateTNSan"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  isRate={true}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Số tiền thưởng nóng sàn"
                  onChange={onChangePriceTNSan}
                  value={displayPriceTNSan}
                  placeholder="Ví dụ: 15000000000 "
                  onFocus={() => handleFocus("priceTNSan")}
                  onBlur={() => handleBlur("priceTNSan")}
                  state={focusStates["priceTNSan"]}
                  register={register("priceTNSan")}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                {/* <InputControl
                  type="number"
                  // step="any"
                  label="Hệ số K"
                  placeholder="Nhập hệ số K"
                  errors={errors.kRate}
                  register={register("kRate")}
                  onFocus={() => handleFocus("kRate")}
                  onBlur={() => handleBlur("kRate")}
                  state={focusStates["kRate"]}
                  mwidth={"100%"}
                  onlyPositiveNumbers={true}
                  // isRate={true}
                /> */}
              </Flex>
              {/* {getRoleUser && (
                <>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                    mb={"16px"}
                  >
                    <InputControl
                      type="number"
                      // step="any"
                      label="% Hoa hồng nhận từ CĐT (X)"
                      placeholder="Nhập % phí dịch vụ nhận từ CĐT (X)"
                      errors={errors.commissionFromInvestor}
                      register={register("commissionFromInvestor")}
                      onFocus={() => handleFocus("commissionFromInvestor")}
                      onBlur={() => handleBlur("commissionFromInvestor")}
                      state={focusStates["commissionFromInvestor"]}
                      mwidth={"100%"}
                      onlyPositiveNumbers={true}
                      isRate={true}
                    />
                    <InputControl
                      type="number"
                      // step="any"
                      label="% Hoa hồng trả cho sale (Y)"
                      placeholder="Nhập % phí dịch vụ trả cho sale (Y)"
                      errors={errors.commissionToSales}
                      register={register("commissionToSales")}
                      onFocus={() => handleFocus("commissionToSales")}
                      onBlur={() => handleBlur("commissionToSales")}
                      state={focusStates["commissionToSales"]}
                      mwidth={"100%"}
                      onlyPositiveNumbers={true}
                      isRate={true}
                    />
                  </Flex>
                  <Flex
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    gap={"27px"}
                  >
                    <InputControl
                      type="number"
                      // step="any"
                      label="% Hoa hồng nhận từ đối tác ngoài CĐT (Z)"
                      placeholder="Nhập % phí dịch vụ nhận từ đối tác ngoài CĐT (Z)"
                      errors={errors.commissionFromPartner}
                      register={register("commissionFromPartner")}
                      onFocus={() => handleFocus("commissionFromPartner")}
                      onBlur={() => handleBlur("commissionFromPartner")}
                      state={focusStates["commissionFromPartner"]}
                      mwidth={"100%"}
                      onlyPositiveNumbers={true}
                      isRate={true}
                    />
                  </Flex>
                </>
              )} */}
            </Box>
            <Flex
              flex={1}
              pr={"24px"}
              alignItems={"center"}
              gap={"16px"}
              justifyContent={"flex-end"}
              // position={"sticky"}
              bottom={"24px"}
              right={"24px"}
              left={"50%"}
            >
              {isEdit ? (
                <>
                  <Button
                    w={"112px"}
                    h={"44px"}
                    lineHeight={"18px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-option-employee-hover)"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    onClick={onClose}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    h={"44px"}
                    lineHeight={"18px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    bg={"var(--linear-gradient-employee)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Lưu
                  </Button>
                </>
              ) : (
                <Button
                  type="submit"
                  padding={"13px 20px"}
                  lineHeight={"18px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  h={"44px"}
                  color={"var(--color-main)"}
                  bg={"var(--linear-gradient-employee)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Thêm căn hộ
                </Button>
              )}
            </Flex>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default FormNew;
